import clsx from 'clsx';
import Img from '@/components/Img';
import styles from './ImageWithText.module.scss';
import Button, { ButtonType } from '@/components/Button/Button';
import Text from '@/components/Text/Text';
import { mediaPath } from '@/mediaPath';

export interface ImageWithTextProps {
  data: {
    title: string;
    description: string;
    image: {
      height: number,
      width: number,
      url: string,
      mime?: string;
    };
    imagePosition?: 'left' | 'right';
    button: {
      id: number,
      title: string,
      type: ButtonType,
      link: string
    }
    imageSize?: 'small' | 'medium' | 'large';
  },
  reverse?: boolean;
}

const ImageWithText = ({ data, reverse }: ImageWithTextProps) => {
  const isVideo = data.image?.mime?.startsWith('video');
  const mediaUrl = data.image?.url ? mediaPath(data.image.url) : null;

  return (
    <section className={clsx(styles.ImageWithText, { [styles.left]: reverse || data.imagePosition === 'left' }, 'custom')}>
      <div className={styles.textContent}>
        {data.title && (
          <Text
            className={styles.title}
            tag='h3'
          >
            {data.title}
          </Text>
        )}
        {data.description && (
          <Text
            tag='p'
            className={styles.description}
          >
            {data.description}
          </Text>
        )}
      </div>
      {data.button && (
        <Button
          type={data.button.type}
          className={styles.primaryButton}
          iconName='arrow_forward'
          href={data.button.link}
        >
          {data.button.title}
        </Button>
      )}
      {mediaUrl && (
        isVideo ? (
          <video
            key={mediaUrl}
            className={clsx(styles.media, data.imageSize && styles[data.imageSize])}
            src={mediaUrl}
            autoPlay
            loop
            muted
            playsInline
            preload='auto'
          >
            <track kind='captions' />
            Your browser does not support the video tag.
          </video>
        ) : (
          <Img
            key={mediaUrl}
            src={data.image.url}
            className={clsx(styles.media, data.imageSize && styles[data.imageSize])}
            height={data.image?.height}
            width={data.image?.width}
            alt={data.title || ''}
          />
        )
      )}
    </section>
  );
};

export default ImageWithText;
